export default __webpack_public_path__ + "static/media/equal.f0c9ab87.svg";